var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaLogIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    fill: "url(#paint0_linear_2826_1231)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    stroke: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5333 13.4734C22.26 13.2001 21.7867 13.3867 21.7867 13.7667V16.0934C21.7867 17.0667 22.6133 17.8734 23.62 17.8734C24.2533 17.8801 25.1333 17.8801 25.8867 17.8801C26.2667 17.8801 26.4667 17.4334 26.2 17.1667C25.24 16.2001 23.52 14.4601 22.5333 13.4734Z",
    fill: "url(#paint1_linear_2826_1231)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 18.7933H23.74C22.16 18.7933 20.8733 17.5066 20.8733 15.9266V13.9999C20.8733 13.6333 20.5733 13.3333 20.2067 13.3333H17.38C15.3267 13.3333 13.6667 14.6666 13.6667 17.0466V22.9533C13.6667 25.3333 15.3267 26.6666 17.38 26.6666H22.62C24.6733 26.6666 26.3333 25.3333 26.3333 22.9533V19.4599C26.3333 19.0933 26.0333 18.7933 25.6667 18.7933ZM19.6667 23.8333H17C16.7267 23.8333 16.5 23.6066 16.5 23.3333C16.5 23.0599 16.7267 22.8333 17 22.8333H19.6667C19.94 22.8333 20.1667 23.0599 20.1667 23.3333C20.1667 23.6066 19.94 23.8333 19.6667 23.8333ZM21 21.1666H17C16.7267 21.1666 16.5 20.9399 16.5 20.6666C16.5 20.3933 16.7267 20.1666 17 20.1666H21C21.2733 20.1666 21.5 20.3933 21.5 20.6666C21.5 20.9399 21.2733 21.1666 21 21.1666Z",
    fill: "url(#paint2_linear_2826_1231)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2826_1231",
    x1: 18.0556,
    y1: 21.1111,
    x2: 6.94445,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C441F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2826_1231",
    x1: 24.0544,
    y1: 13.3435,
    x2: 24.0544,
    y2: 17.8801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCBCF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2826_1231",
    x1: 20,
    y1: 13.3333,
    x2: 20,
    y2: 26.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCBCF1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaLogIcon);
export default __webpack_public_path__ + "static/media/SA_LogIcon.6b0a8fd469e0380b739f9a74958cfe5d.svg";
export { ForwardRef as ReactComponent };